<template>
    <v-navigation-drawer dark v-model="showSidebar" app>
        <v-list-item class="logo-container">
            <Link href="/">
                <side-bar-logo />
            </Link>
        </v-list-item>

        <!-- drawer menu items -->
        <v-list class="sidebar-drawer">
            <div v-for="item in items" :key="item.id">
                <v-list-group
                    v-if="item.items.length > 0"
                    no-action
                    :prepend-icon="item.icon"
                    v-model="item.active"
                    v-show="!showDataSource(item.id)"

                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>
                                <template v-if="item.active">
                                    <b>{{ item.title }}</b>
                                </template>
                                <template v-else>
                                    {{ item.title }}
                                </template>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                        v-for="subItem in item.items"
                        class="sub-item"
                        v-model="subItem.active"
                        :key="subItem.id"
                        @click="onDrawerItemClick(subItem, [item])"
                        link
                    >
                        <v-icon v-if="subItem.icon">{{ subItem.icon }}</v-icon>
                        <v-list-item-title>
                            <template v-if="subItem.active">
                                <b>{{ subItem.title }}</b>
                            </template>
                            <template v-else>
                                {{ subItem.title }}
                            </template>
                        </v-list-item-title>
                    </v-list-item>
                </v-list-group>
                <v-list-item
                    v-else-if="item.external_link"
                    v-show="checkPermission('DOCUMENTS_REDIRECT')"
                    :href="item.external_link"
                    v-model="item.active"
                    target="_blank"
                    rel="noopener noreferrer"
                    link
                    @click="onDrawerItemClick(item)"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <template v-if="item.active">
                            <b>{{ item.title }}</b>
                        </template>
                        <template v-else>
                            {{ item.title }}
                        </template>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-else
                    v-model="item.active"
                    link
                    @click="onDrawerItemClick(item)"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <template v-if="item.active">
                            <b>{{ item.title }}</b>
                        </template>
                        <template v-else>
                            {{ item.title }}
                        </template>
                    </v-list-item-title>
                </v-list-item>
            </div>
        </v-list>
        <template v-slot:append>
            <div class="copyright-notice">
                {{ $t('app.copyright') }}
                <br />
                {{ $t('app.uneatlantico') }} {{ currentYear }}
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import SideBarLogo from "@/Shared/ImagesSVG/SideBarLogo.vue";
import {Link} from "@inertiajs/inertia-vue";
import {SidebarItems} from "@/Store/sidebar-items";
import SidebarItemsRepository from "@/Repositories/SidebarItemsRepository";
import {mapActions, mapState} from "pinia";
import dayjs from "dayjs";
import {PermissionsStore} from "@/Store/PermissionsStore";

export default {
    components: {
        SideBarLogo,
        Link,
    },

    props: {
        value: {
            type: Boolean,
        },
    },

    data: () => ({
        currentYear: dayjs().format('YYYY'),
    }),

    methods: {
        onDrawerItemClick(item, ancestors) {
            item = this.setItemActive(item, ancestors);

            if(item && item.route) {
                this.$inertia.get(item.route);
            }
        },

        showDataSource(id) {
            return id==='data-sources' && !this.checkPermission('DATA_SOURCES_GLOBAL_VIEW')
        },

        ...mapActions(SidebarItems, ['setItemActive', 'setItems']),
        ...mapActions(PermissionsStore, ['setPermissions', 'checkPermission']),
    },

    computed: {
        ...mapState(SidebarItems, ['items', 'href']),
        ...mapState(PermissionsStore, ['permissions']),

        showSidebar: {
            get() {
                return this.value;
            },
            set(value) {
                if (!value) this.$emit("hideSidebar");
            },
        },
    },

    mounted() {
        this.setPermissions();
        this.setItems(SidebarItemsRepository.all());
    },

    created() {

    }
};
</script>

<style scoped>
</style>
